<template>
<div>
  <el-dialog
    :title="type === 'add' ? '新增': '编辑'"
    :visible.sync="dialogShow"
    :close-on-click-modal="false"
    :append-to-body="false"
    width="1300px"
    v-dialogDrag
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      inline
      label-width="100px"
      size="small"
    >
      <el-form-item label="区域名称" prop="name">
        <el-input
          v-model="ruleForm.name"
          placeholder="请输入"
          class="!w-199px"
        ></el-input>
      </el-form-item>
      <el-form-item label="区域编码" prop="areaCode">
        <el-input
          v-model="ruleForm.areaCode"
          placeholder="请输入"
          class="!w-199px"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="mt-20px">
        <div class="relative mb-10px">
            <div class="text-15px bold">人员出入状态记录</div>
            <el-button
              type="primary"
              size="small"
              class="absolute right-75px bottom-0"
              @click="showDoorDialog = true"
              native-type="submit"
              >添加门禁</el-button
            >
            <el-button
              type="danger"
              size="small"
              @click="deletaTableDatas"
              class="absolute right-0 bottom-0"
              >删除</el-button
            >
        </div>
        <el-divider class="mt-10px"></el-divider>
        <el-table
            :data="tableData"
            border
            stripe
            height="300px"
            @selection-change="handleSelectionChange"
            v-loading="tableLoading"
        >
            <el-table-column  type="selection" align="center" width="50px"></el-table-column>
            <el-table-column label="序号"  align="center" show-overflow-tooltip type="index" width="80px"></el-table-column>
            <el-table-column label="门禁设备编号" prop="deviceCode" align="center" show-overflow-tooltip=""></el-table-column>
            <el-table-column label="门禁设备名称" prop="deviceName" align="center" show-overflow-tooltip=""></el-table-column>
            <el-table-column label="操作" prop="" align="center">
              <template slot-scope="scope">
                <el-button size="small" @click="handleDelete(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
        </el-table>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" @click="confirm" :loading="saveLoading">保存</el-button>
      <el-button @click="dialogShow = false" size="small">取消</el-button>
    </div>
  </el-dialog>
  <SelectDoorList
    @close="showDoorDialog = false"
    @success="successData"
    :visible.sync="showDoorDialog"
    v-if="showDoorDialog"
  />
</div>

</template>

<script>
import { DataCategoryApi } from '@wiz-api/data-category-management'
import { IOTGateAreaRangeApi } from '@wiz-api/iot-device-management'
import SelectDoorList from './components/SelectDoorList'

const iotGateAreaRangeApi = new IOTGateAreaRangeApi()
const dataCategoryApi = new DataCategoryApi()
export default {
  props: {
    show: Boolean,
    type: {
      type: String,
      default: 'edit',
    },
    detailRow: Object,
    index: Number,
  },
  components: {
    SelectDoorList,
  },
  data() {
    return {
      showDoorDialog: false,
      ruleForm: {
        name: '',
        code: '',
      },
      tableLoading: false,
      rules: {
        name: [{ required: true, message: '请选择', trigger: 'change' }],
        areaCode: [{ required: true, message: '请输入', trigger: 'blur' }],
      },
      facturerList: [],
      deviceTypeList: [],
      templateFieldTypeList: [],
      protocolList: [],
      saveLoading: false,
      selectList: [],
      tableData: [],
      deleteFieldIds: []
    }
  },
  computed: {
    dialogShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      },
    },
  },
  methods: {
    successData(data) {
      let flag = false
      data.forEach((item) => {
        const tepData = this.tableData.find((item1) => { return item1.id === item.tag3DPositionRelationKey })
        if (!tepData) {
          this.tableData.push({
            id: item.tag3DPositionRelationKey,
            deviceName: item.name,
            deviceCode: item.code,
          })
        } else {
          flag = true
        }
      })
      if (flag) {
        this.$message.warning('门禁已存在')
      }
      // 门禁选择成功
      // const tepData = this.tableData.find((item) => { return item.id === data.id })
      // if (tepData) return
    },
    handleDelete(index) {
      // 删除门禁}
      this.$confirm('确认删除该门禁吗？')
        .then(() => {
          // this.tableData.splice(index, 1)
          this.$delete(this.tableData, index)
        })
        .catch(() => {})
    },
    confirm() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          // this.saveLoading = true
          const tempIds = this.tableData.map((item) => { return item.id })
          const [err] = this.type === 'add' ?
            await iotGateAreaRangeApi.createAreaRange({
              body: {
                name: this.ruleForm.name,
                areaCode: this.ruleForm.areaCode,
                gateDeviceIds: tempIds || null,
              }
            }) :
            await iotGateAreaRangeApi.editAreaRange({
              body: {
                name: this.ruleForm.name,
                areaCode: this.ruleForm.areaCode,
                id: this.ruleForm.id,
                gateDeviceIds: tempIds || null,
              }
            })
          if (!err) {
            this.$emit('reload', this.index)
            this.$message.success(this.type === 'add' ? '新增成功' : '编辑成功')
            this.dialogShow = false
          }
        }
      })
    },
    // 获取数据字典数据
    async getCategoryByCodes() {
      const [err, res] = await dataCategoryApi.getListByCodes({
        codes: ['IOTDeviceTemplateManufacturer', 'IOTDeviceTemplateDeviceType', 'IOTDeviceTemplateFieldType'],
        includeDetails: true,
      })
      if (!err) {
        let facturerList = []
        let deviceTypeList = []
        let templateFieldTypeList = []
        res.forEach((item) => {
          if (item.code === 'IOTDeviceTemplateManufacturer') { // 设备厂商
            facturerList = item.dataItems
          }
          if (item.code === 'IOTDeviceTemplateDeviceType') { // 类型归属
            deviceTypeList = item.dataItems
          }
          if (item.code === 'IOTDeviceTemplateFieldType') { // 数据类型
            templateFieldTypeList = item.dataItems
          }
        })
        this.facturerList = facturerList
        this.deviceTypeList = deviceTypeList
        this.templateFieldTypeList = templateFieldTypeList
      }
    },
    // 获取详情
    async getDetail() {
      const [err, res] = await iotGateAreaRangeApi.getAreaRange(this.detailRow.id)
      if (!err) {
        this.ruleForm = res
        this.tableData = res.devices
      }
    },
    // 选择门禁
    handleSelectionChange(val) {
      this.selectList = val.map((item) => { return item.id })
    },
    // 删除门禁
    deletaTableDatas() {
      if (this.selectList.length === 0) {
        this.$message.warning('请选择门禁')
        return
      }
      this.$confirm('确认删除所选门禁吗？')
        .then(() => {
          this.tableData = this.tableData.filter((item) => {
            return !this.selectList.includes(item.id)
          })
          this.tableData = JSON.parse(JSON.stringify(this.tableData))
          this.selectList = []
        })
        .catch(() => {})
    }
  },
  created() {
    // this.getCategoryByCodes()
    if (this.type === 'edit') {
      this.getDetail()
    } else {
      this.tableData = []
    }
  }
}
</script>
